import React, { useEffect, useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Yup from "yup";
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { FastField, Field, Formik } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import { useTranslation } from 'react-i18next';
import AppColors from 'general/constants/AppColors';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize, KTBSButtonType } from 'general/components/OtherKeenComponents/KTBSButton';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import { useSelector } from 'react-redux';
import AppConfigs from 'general/constants/AppConfigs';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import Global from 'general/utils/Global';
import ToastHelper from 'general/helpers/ToastHelper';
import useRouter from 'hooks/useRouter';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import { AppDialogHelper } from 'general/components/AppDialog';
import AppRoute from 'general/constants/AppRoute';
import InputSearchDropdown from 'general/components/Others/InputSearchDropdown';
import axiosClient from 'api/axiosClient';
import CustomAlert from 'general/components/Others/CustomAlert';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import InvestorHelper from 'features/ManageInvestor/investorHelper';


ModelConfigInvestorTableColumn.propTypes = {};

function ModelConfigInvestorTableColumn(props) {
    const { t } = useTranslation();
    const { dialogShowing, handleClose, handleSubmit, setFilter } = props;

    return (
        <Modal
            className="font-size-base font-weight-bold modal-dialog-scrollable"
            show={dialogShowing}
            onHide={handleClose}
            width="500px"
            centered
            style={{
                color: AppColors.gray[800],
            }}
        >
            <Modal.Body>
                <div className="d-flex align-items-end flex-wrap">
                    <div className="col-12 px-0 py-2">
                        <KTFormSearch
                            name="search-bar"
                            placeholder={t('Tìm kiếm (theo mã nđt, tên nđt, số điện thoại, email, MST/CCCD)')}
                            value={Global.g_filterInvestorList.q}
                            onSubmit={(text) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    q: text,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                        />
                    </div>

                    {/* Cấp nhà đầu tư */}
                    <div className="col-md-6 col-sm-12 pl-0 py-2">
                        <label htmlFor="level" className="mb-0 mr-2 font-weight-bolder">
                            {t('Cấp nhà đầu tư')}
                        </label>
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {InvestorHelper.filterInvestorLevelOptions().find(
                                        (item) => item.value === Global.g_filterInvestorList.level
                                    )?.name ?? t('all')}
                                </button>
                            }
                            selectedValue={Global.g_filterInvestorList.level}
                            dropdownMenuItems={InvestorHelper.filterInvestorLevelOptions()}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    level: value,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                            isDropdownForm={true}
                        />
                    </div>

                    {/* Loại nhà đầu tư */}
                    <div className="col-md-6 col-sm-12 pr-0 py-2">
                        <label htmlFor="type" className="mb-0 mr-2 font-weight-bolder">
                            {t('Loại nhà đầu tư')}
                        </label>
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {InvestorHelper.filterInvestorTypeOptions().find(
                                        (item) => item.value === Global.g_filterInvestorList.type
                                    )?.name ?? t('all')}
                                </button>
                            }
                            selectedValue={Global.g_filterInvestorList.type}
                            dropdownMenuItems={InvestorHelper.filterInvestorTypeOptions()}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    type: value,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                            isDropdownForm={true}
                        />
                    </div>

                    {/* trang thai */}
                    <div className="col-md-6 col-sm-12 pl-0 py-2">
                        <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                            {t('Trạng thái')}
                        </label>
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {DealerHelper.filterStatusOptions().find(
                                        (item) => item.value === Global.g_filterInvestorList.status
                                    )?.name ?? t('all')}
                                </button>
                            }
                            selectedValue={Global.g_filterInvestorList.status}
                            dropdownMenuItems={DealerHelper.filterStatusOptions()}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    status: value,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                            isDropdownForm={true}
                        />
                    </div>

                    {/* thời gian thống kê */}
                    <div className="col-md-6 col-sm-12 pr-0 py-2">
                        <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                            {t('Khoảng thời gian thống kê')}
                        </label>
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {DealerHelper.filterStatusOptions().find(
                                        (item) => item.value === Global.g_filterInvestorList.status
                                    )?.name ?? t('all')}
                                </button>
                            }
                            selectedValue={Global.g_filterInvestorList.status}
                            dropdownMenuItems={DealerHelper.filterStatusOptions()}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    status: value,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                            isDropdownForm={true}
                        />
                    </div>

                    <hr className='my-3' style={{ width: '100%', border: `1px dashed ${AppColors.gray[300]}` }} />

                    {/* tinh thanh pho */}
                    <div className="col-md-6 col-sm-12 pl-0 py-2">
                        <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                            {t('Tỉnh/Thành phố')}
                        </label>
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {DealerHelper.filterStatusOptions().find(
                                        (item) => item.value === Global.g_filterInvestorList.status
                                    )?.name ?? t('all')}
                                </button>
                            }
                            selectedValue={Global.g_filterInvestorList.status}
                            dropdownMenuItems={DealerHelper.filterStatusOptions()}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    status: value,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                            isDropdownForm={true}
                        />
                    </div>

                    {/* quan huyen */}
                    <div className="col-md-6 col-sm-12 pr-0 py-2">
                        <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                            {t('Phường/Xã')}
                        </label>
                        <KTBSDropdown
                            toggleElement={
                                <button
                                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                    type="button"
                                >
                                    {DealerHelper.filterStatusOptions().find(
                                        (item) => item.value === Global.g_filterInvestorList.status
                                    )?.name ?? t('all')}
                                </button>
                            }
                            selectedValue={Global.g_filterInvestorList.status}
                            dropdownMenuItems={DealerHelper.filterStatusOptions()}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                                Global.g_filterInvestorList = {
                                    ...Global.g_filterInvestorList,
                                    status: value,
                                };
                                // setFilter(Global.g_filterInvestorList);
                            }}
                            isDropdownForm={true}
                        />
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer style={{ height: "3.5 rem" }}>
                <Button
                    variant="secondary"
                    className="font-weight-bold mr-2"
                    onClick={handleClose}
                >
                    {t('Đặt lại mặc định')}
                </Button>

                <Button
                    variant="success"
                    className="font-weight-bold"
                    onClick={() => {
                        setFilter(Global.g_filterInvestorList);
                        handleSubmit();
                    }}
                >
                    {t('Lọc ngay')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModelConfigInvestorTableColumn;
